/* eslint-disable react/jsx-pascal-case */
import { createContext, useContext } from "react";
import { Route, Routes } from "react-router-dom"
import Label_language from "../language";
import Main from "../utility/Main";
import { ConfigProvider } from 'antd';
import InventoryAudit from './views/Inventory/inventory_audit';
import CapacityWarning from './views/Inventory/capacity_warning';
import WarehouseStatistics from './views/Inventory/warehouse_statistics';
import UtilizationAnalysis from './views/Inventory/utilization_analysis';
import InventoryStatistics from './views/Inventory/inventory_statistics';
import DemandForecast from './views/Inventory/demand_forecast';
import PositionManagement, { AttributeManagement } from './views/position_management'
import PositionTest from './views/position_test'
import { Mainlayout } from "../ui/ot";
import PlanManagement from "./views/plan_management";
// import InventorySetting from "./views/Inventory/inventorySetting"
// import StockInForm from "./views/StockInOverview/stock_in_form"
// import ReceivingProgress from "./views/StockInOverview/ReceivingProgress"
// import Order from "./views/StockInOverview/Order"
// import StoringV2 from "./views/StockInOverview/StoringV2"
// import Check from "./views/StockInOverview/Check"
// import ShipOutOverview from "./views/ShipOutOverview/ship_out_overview"
// import InsertShipOutOrder from "./views/ShipOutOverview/ship_out_form"
// import ShipOutRecords from "./views/ShipOutOverview/ship_out_item_record"
// import Item from './views/item'
// import Return from './views/Return'
export const Language_context = createContext();
const { ConfigContext } = ConfigProvider;
const label_language = Label_language.inventory_check
const MainRoute = (props) => {
    const configContext = useContext(ConfigContext);
    const language = configContext.locale.locale
    return (
        <Routes>
            <Route path={''} element={<Mainlayout />}>
                <Route path={''} element={
                    <Main
                        language={label_language}
                    />
                } />
                <Route path={'position'} element={
                    <PositionManagement />
                } />
                <Route path={'positionTest'} element={
                    <PositionTest />
                } />
                <Route path={'attribute'} element={
                    <AttributeManagement />
                } />
                <Route path={'plan'} element={
                    <PlanManagement />
                } />
                <Route path={'plan_record'} element={
                    []
                } />
                <Route path={'inventory_audit'} element={
                    <InventoryAudit />
                } />
                <Route path={'capacity_warning'} element={
                    <CapacityWarning />
                } />
                <Route path={'warehouse_statistics'} element={
                    <WarehouseStatistics />
                } />
                <Route path={'utilization_analysis'} element={
                    <UtilizationAnalysis />
                } />
                <Route path={'inventory_statistics'} element={
                    <InventoryStatistics />
                } />
                <Route path={'demand_forecast'} element={
                    <DemandForecast />
                } />
                {/* <Route index element={
                <MainPage />
            }
            /> */}
                {/* <Route path={'inventory'}>
                <Route path={""} element={
                    <InventorySetting />
                }
                />
                <Route path={"post_stock_in"}
                        element={
                            <StockInForm />
                        }
                    />
                    <Route path={"stock_in_item_record"}
                        element={
                            <StoringV2 />
                        }
                    />
            </Route> */}


                {/* <Route path={"/item"} element={
                <Item />
            }
            />
            <Route path={"/return"} element={
                <Return />
            }
            /> */}
                {/* <Route path={'/ShipOutOverview'}>
                <Route path={""} element={
                    <ShipOutOverview />
                }
                />
                <Route path={"post_ship_out"} element={
                    <InsertShipOutOrder />
                }
                />
                <Route path={"post_ship_out_item_record"} element={
                    <ShipOutRecords />
                }
                />
            </Route> */}
                {/* <Route path={"/StockInOverview/UpdateOrder/:stock_in_id"}
                element={
                    <Main_layout
                        path={[
                            {
                                name: label_language[language],
                                path: "/stock_in_and_ship_out"
                            },
                            {
                                name: label_language.children.StockInOverview[language],
                                path: "/stock_in_and_ship_out/StockInOverview"
                            },
                            {
                                name: label_language.children.StockInOverview.children.UpdateOrder[language],
                                path: "/stock_in_and_ship_out/StockInOverview/UpdateOrder"
                            }
                        ]}
                        title={label_language.children.StockInOverview.children.UpdateOrder[language]}
                    >
                        <StockInForm />
                    </Main_layout>
                }
            />
            <Route path={"/StockInOverview/ReceivingProgress/*"}
                element={
                    <Main_layout
                        path={[
                            {
                                name: label_language[language],
                                path: "/stock_in_and_ship_out"
                            },
                            {
                                name: label_language.children.StockInOverview[language],
                                path: "/stock_in_and_ship_out/StockInOverview"
                            }
                        ]}
                        title={label_language.children.StockInOverview.children.ReceivingProgress[language]}
                    >
                        <ReceivingProgress />
                    </Main_layout>
                }
            />
            <Route path={"/StockInOverview/Order/*"}
                element={
                    <Main_layout
                        path={[
                            {
                                name: label_language[language],
                                path: "/stock_in_and_ship_out"
                            },
                            {
                                name: label_language.children.StockInOverview[language],
                                path: "/stock_in_and_ship_out/StockInOverview"
                            },
                            // {
                            //     name: label_language.children.StockInOverview.children.Order[language],
                            //     path: "/stock_in_and_ship_out/StockInOverview/Order"
                            // }
                        ]}
                        title={label_language.children.StockInOverview.children.Order[language]}
                    >
                        <Order />
                    </Main_layout>
                }
            />
            <Route path={"/StockInOverview/ProductAcceptance/Check/*"}
                element={
                    <Main_layout
                        path={[
                            {
                                name: label_language[language],
                                path: "/stock_in_and_ship_out"
                            },
                            {
                                name: label_language.children.StockInOverview[language],
                                path: "/stock_in_and_ship_out/StockInOverview"
                            },
                            {
                                name: label_language.children.StockInOverview.children.ProductAcceptance[language],
                                path: "/stock_in_and_ship_out/StockInOverview/ProductAcceptance"
                            },
                            ,
                            {
                                name: label_language.children.StockInOverview.children.ProductAcceptance.children.Check[language],
                                path: "/stock_in_and_ship_out/StockInOverview/ProductAcceptance/Check"
                            }
                        ]}
                        title={label_language.children.StockInOverview.children.ProductAcceptance.children.Check[language]}
                    >
                        <Check />
                    </Main_layout>
                }
            />
            <Route path={"/ShipOutOverview/UpdateOrder/:ship_out_id"}
                element={
                    <Main_layout
                        path={[
                            {
                                name: label_language[language],
                                path: "/stock_in_and_ship_out"
                            },
                            {
                                name: label_language.children.ShipOutOverview[language],
                                path: "/stock_in_and_ship_out/ShipOutOverview"
                            },
                            {
                                name: label_language.children.ShipOutOverview.children.UpdateOrder[language],
                                path: "/stock_in_and_ship_out/ShipOutOverview/UpdateOrder"
                            }
                        ]}
                        title={label_language.children.ShipOutOverview.children.UpdateOrder[language]}
                    >
                        <InsertShipOutOrder />
                    </Main_layout>
                }
            /> */}
            </Route>
        </Routes>
    )
}
export default MainRoute;

